import styled from "styled-components";
import { CodeInput } from "../components/CodeAccess/CodeInput/CodeInput";

const Container = styled("div")`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CodeInputWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(1.5px);
  -webkit-backdrop-filter: blur(1.5px);
  border: 2px solid #e2e4ea;
`;

const Title = styled("h2")`
  padding: 16px 24px;
  color: #1a1e3f;
  border-bottom: 1px solid #e2e4ea;
  box-sizing: border-box;
  font-family: "Versos", sans-serif;
  font-size: 1.325rem;
  width: 100%;
  text-align: center;
`;

export const CodeAccess = (): JSX.Element => {
  return (
    <Container>
      <CodeInputWrapper>
        <Title>Insira o código da teleconsulta abaixo</Title>

        <CodeInput />
      </CodeInputWrapper>
    </Container>
  );
};
